import React from 'react'
import '../styles/footer.css'

const Footer = () => {
  return (
    <div className='footer-wrapper'>
        <div className="footer-content">
            <p>© 2023 All rights reserved&nbsp; | &nbsp;Made with ♡ by Sumit Pandey</p>
        </div>
    </div>
  )
}

export default Footer